import { Link } from "react-router-dom";
import { Col, Container } from "reactstrap";
import { P } from "../../../../../AbstractElements";
import { Error3 } from "../../../../../Data/Pages/Pages";

const Error403 = () => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="error-wrapper">
        <Container>
          <div className="svg-wrraper">
            <Error3 />
          </div>
          <Col md="8" className="offset-md-2">
            <P className="sub-content">{"The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."}</P>
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`} className="btn btn-primary btn-lg">
              {"BACK TO HOME PAGE"}
            </Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default Error403;
